export default __webpack_public_path__ + "49f9520e9ca04b8812e26bf548c09eae.webp";